import React, { useState } from 'react';
import ReusableDiv from "src/helper/ReusableDiv";
import Helper from "src/helper/Helper";
import { useUserStore } from "src/hooks/admin/user";
import Constants from "src/helper/Constants";
import System from "src/helper/system";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import useReduxState from "src/hooks/useReduxState";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ShowAlert from 'src/component/Global/ShowAlert';

const AddUser = (props) => {
  const { SetStatus } = props;
  const [{ }, { }, { add_user, check_user_email }] = useUserStore();
  const emailPattern = Helper.getEmailPattern();
  const specialChartFollowedBy2 = Helper.getSpecialChartFollowedBy2Pattern();
  const [__check] = useAxiosIndicatorCheck();
  const [detailValidation, setDetailValidation] = useState({});
  const [, setRefreshGrid] = useReduxState(false, "setRefreshGrid");
  const [{}, { system_alert_indicator }, {}] = useDOMAttachToSystemStore();
  const namePattern = /^[a-zA-Z~!$%^&-_=+{}\[\]:<>.|俊容洪šž辉季áí赵凯济同张丁弘ň()段超琼ğ康云宝öüélèsi*陈华景å'@ø李金成JÃƒÂ¶rgłD´Ż©ÖMÆ’‚,¼he#? ]*$/u;
  const alphaNumPattern = /^[A-Za-z0-9\s]+$/;

  const [emailStatus, setEmailStatus] = useState(false)
  const loader = __check('ADD_USER_API_CALL').status;

  const modal = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    mobileNumber: "",
    telephoneNumber: "",
    userType: "External",
    registeredSpeedBoat: System.avUserInfoData.speedBoatAbbr,
    companyName: "",
  };
  const [userDetail, setUserDetail] = useState(modal);
  const { userType: { INTERNAL, EXTERNAL } } = Constants

  const onHide = () => {
    SetStatus(false);
  };

  const onValueChange = (field, value) => {
    if (detailValidation && Object.keys(detailValidation).length > 0) {
      delete detailValidation[field];
    }
    setUserDetail({ ...userDetail, [field]: value });

    if (userDetail.userType === INTERNAL && field === 'emailAddress' && emailStatus) {
      setUserDetail({ ...modal, emailAddress: value, userType: INTERNAL });
    }

    if (field === "userType") {
      setUserDetail({ ...modal, userType: value });
      setDetailValidation({});
    }


  };

  const onExistingEmailCheck = async () => {

    const isValid = validateEmail()

    if (isValid) {
      __set("CHECK_USER_EMAIL");
      const res = await check_user_email(userDetail.emailAddress)
      if (res && res?.isSuccessFull) {
        setEmailStatus(true)
        setUserDetail({ ...res?.data, userType: res?.data?.userType === 0 ? INTERNAL : EXTERNAL, registeredSpeedBoat: System.avUserInfoData.speedBoatAbbr })
      } else if (res && res.Message) {
        const validationModal = {}
        validationModal.emailAddress = res.Message;
        setDetailValidation(validationModal);
      } else {

        system_alert_indicator({
          name: "addUserError",
          message: "Oh snap! The user could not be added. Please try again.",
          type: "danger",
          isDisplay: false,
          isDisplayIcon: true,
          addUsercontainer: true
        });

      }
      __remove("CHECK_USER_EMAIL");
    }
  };

  const onSaveUser = async () => {

    __set("ADD_USER_API_CALL");

    const isValid = userDetail?.userType === "External" ? onValidateData() : validateEmail()
    if (isValid) {
      Object.entries(userDetail).every(([field, value]) => {})
      const res = await add_user(userDetail);
      if (res && res.isSuccessFull) {
        const message = userDetail?.userType === "External" ? ("You have successfully added " +
          res.username +
          " to the system. An email has been sent to them for confirmation") : ("You have successfully added " +
          res.username + " to the system.")
        setTimeout(() => {
          system_alert_indicator({
            name: "adminconsole",
            message: message,
            type: "success",
            isDisplay: true,
          });
          setRefreshGrid(true);
        }, 500);

        onHide();
      } else if (res && res.Message) {
        const validationModal = {}
        if (['422', '402', '404'].includes(res?.ErrorCode)) {
          validationModal.emailAddress = res.Message;
          setDetailValidation(validationModal);
        } else {
          system_alert_indicator({
            name: "addUserError",
            message: "Oh snap! The user could not be added. Please try again.",
            type: "danger",
            isDisplay: false,
            isDisplayIcon: true,
            addUsercontainer: true
          });
        }
      } else {
        system_alert_indicator({
          name: "addUserError",
          message: "Oh snap! The user could not be added. Please try again.",
          type: "danger",
          isDisplay: false,
          isDisplayIcon: true,
          addUsercontainer: true
        });
      }
    }

    __remove("ADD_USER_API_CALL");
  };

  const onValidateData = () => {
    const validationModal = {};
    if (!Helper.valueIsNotNull(userDetail.firstName)) {
      validationModal.firstName = "Enter First Name";
    }

    if (!Helper.valueIsNotNull(userDetail.lastName)) {
      validationModal.lastName = "Enter Last Name";
    }

    if (!Helper.valueIsNotNull(userDetail.emailAddress)) {
      validationModal.emailAddress = "Enter Email Address"
    } else if (!Helper.validateRegex(userDetail.emailAddress, emailPattern)) {
      validationModal.emailAddress = "Invalid Email, Please enter valid Email Address";
    } else if (System.validateDomain(userDetail.emailAddress)) {
      validationModal.emailAddress = "For Avnet users, please select the internal user option.";
    }

    if (!Helper.valueIsNotNull(userDetail.mobileNumber) || !Helper.validateRegex(userDetail.mobileNumber, Constants.alphaNum)) {
      validationModal.mobileNumber = "Enter Mobile Number"
    }

    if (userDetail.userType === EXTERNAL && !Helper.valueIsNotNull(userDetail.companyName)) {
      validationModal.mobileNumber = "Enter Company Name"
    }

    setDetailValidation(validationModal);
    return Object.keys(validationModal).length <= 0;
  };

  const validateEmail = () => {
    const validationModal = {};
    if (!Helper.valueIsNotNull(userDetail.emailAddress)) {
      validationModal.emailAddress = "Enter Email Address";
    } else if (!Helper.validateRegex(userDetail.emailAddress, emailPattern)) {
      validationModal.emailAddress = "Invalid Email, Please enter valid Email Address"
    } else if (!System.validateDomain(userDetail.emailAddress)) {
      validationModal.emailAddress = "For external users, please select external option.";
    }

    setDetailValidation(validationModal);
    return Object.keys(validationModal).length <= 0;
  }

  const enableField = Helper.valueIsNotNull(userDetail.firstName) && Helper.valueIsNotNull(userDetail.lastName) &&
    Helper.valueIsNotNull(userDetail.emailAddress) && Helper.validateRegex(userDetail.emailAddress, emailPattern) &&
    (Helper.valueIsNotNull(userDetail.companyName) || userDetail.userType === INTERNAL) && Object.keys(detailValidation).length === 0


  const UserFields = () => {
    const valid = userDetail?.userType === "External"
    return (
      <>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="firstName" className="d-block">
                First Name*
              </label>
              <input
                maxLength={50}
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.firstName
                  ? " error"
                  : ""
                }`}
                id="firstName"
                placeholder="First Name"
                name="firstName"
                value={userDetail.firstName}
                onChange={({ target: { value } }) =>
                  onValueChange("firstName", value)
                }
                disabled={!valid}
                onBlur={() => {
                  if (userDetail.firstName) {
                    if (userDetail.firstName?.length < 3) {
                      setDetailValidation({ ...detailValidation, firstName: 'First name must not be less than 3 characters.' });
                      return;
                    }
                    if (!namePattern.test(userDetail.firstName)) {
                      setDetailValidation({ ...detailValidation, firstName: 'Entered characters are not valid.' });
                      return;
                    }
                  }
                }}
              />
              {valid && detailValidation.firstName && (
                <p className="error"> {detailValidation.firstName}</p>
              )}
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label htmlFor="mobileNumber" className="d-block">
                Mobile Number*
              </label>
              <input
                maxLength={32}
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.mobileNumber
                  ? " error"
                  : ""
                }`}
                id="mobileNumber"
                placeholder="Mobile Number"
                name="mobileNumber"
                value={userDetail.mobileNumber}
                onChange={({ target: { value } }) =>
                  onValueChange("mobileNumber", value)
                }
                disabled={!valid}
                onBlur={() => {
                  if (userDetail.mobileNumber) {
                    if (!alphaNumPattern.test(userDetail.mobileNumber)) {
                      setDetailValidation({ ...detailValidation, mobileNumber: 'Phone Number must be entered in Alphanumeric and must not contain special characters.' });
                    }
                  }
                }}
              />
              {valid && detailValidation.mobileNumber && (
                <p className="error"> {detailValidation.mobileNumber}</p>
              )}
            </div>
          </div>
        </div>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="lastName" className="d-block">
                Last Name*
              </label>
              <input
                maxLength={50}
                type="text"
                className={`form-control form-control-sm ${valid && detailValidation && detailValidation.lastName
                  ? " error"
                  : ""
                }`}
                id="lastName"
                placeholder="Last Name"
                name="lastName"
                value={userDetail.lastName}
                onChange={({ target: { value } }) =>
                  onValueChange("lastName", value)
                }
                disabled={!valid}
                onBlur={() => {
                  if (userDetail.lastName) {
                    if (userDetail.lastName?.length < 3) {
                      setDetailValidation({ ...detailValidation, lastName: 'Last name must not be less than 3 characters.' });
                      return;
                    }
                    if (!namePattern.test(userDetail.lastName)) {
                      setDetailValidation({ ...detailValidation, lastName: 'Entered characters are not valid.' });
                      return;
                    }
                  }
                }}
              />
              {valid && detailValidation.lastName && (
                <p className="error"> {detailValidation.lastName}</p>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="telephoneNumber" className="d-block">
                Telephone Number
              </label>
              <input
                maxLength={32}
                type="text"
                className="form-control form-control-sm"
                id="telephoneNumber"
                placeholder="Telephone Number"
                name="telephoneNumber"
                value={userDetail.telephoneNumber}
                onChange={({ target: { value } }) =>
                  onValueChange("telephoneNumber", value)
                }
                disabled={!valid}
                onBlur={() => {
                  if (userDetail.telephoneNumber) {
                    if (!alphaNumPattern.test(userDetail.telephoneNumber)) {
                      setDetailValidation({ ...detailValidation, telephoneNumber: 'Telephone Number must be entered in Alphanumeric and must not contain special characters.' });
                      return;
                    }
                  }
                }}
              />
              {detailValidation.telephoneNumber && (
                <p className="error">
                  {" "}
                  {detailValidation.telephoneNumber}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className=" bs5 row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="email" className="d-block">
                Email Address*
              </label>
              <input
                maxLength={50}
                type="text"
                className={`form-control form-control-sm ${detailValidation && detailValidation.emailAddress
                  ? " error" : "" }`}
                id="email"
                placeholder="Email Address"
                name="emailAddress"
                value={userDetail.emailAddress}
                onChange={({ target: { value } }) =>
                  onValueChange("emailAddress", value)
                }
                onBlur={() => {
                  if (userDetail.emailAddress) {
                    if (!emailPattern.test(userDetail.emailAddress)) {
                      setDetailValidation({ ...detailValidation, emailAddress: 'Invalid email. Special characters (, _, ., -, %,+) must be followed by letters or numbers' });
                      return;
                    }
                    if (!valid) {
                      onExistingEmailCheck()
                    }
                  }
                }}
              />
              {detailValidation.emailAddress && (
                <p className="error">
                  {" "}
                  {detailValidation.emailAddress}
                </p>
              )}
            </div>
          </div>
          {userDetail.userType === EXTERNAL && <div className="col-6">
            <div className="form-group">
              <label htmlFor="companyName" className="d-block">
                Company Name*
              </label>
              <input
                maxLength={100}
                type="text"
                className={`form-control form-control-sm ${detailValidation && detailValidation.companyName
                  ? " error" : ""}`}
                id="companyName"
                placeholder="Company Name"
                name="companyName"
                value={userDetail.companyName}
                onChange={({ target: { value } }) =>
                  onValueChange("companyName", value)
                }
                onBlur={() => {
                  if (userDetail.companyName) {
                    if (!namePattern.test(userDetail.companyName)) {
                      setDetailValidation({ ...detailValidation, companyName: 'Entered characters are not valid.' });
                      return;
                    }
                  }
                }}
              />
              {detailValidation.companyName && (
                <p className="error">
                  {" "}
                  {detailValidation.companyName}
                </p>
              )}
            </div>
          </div>}
          <div className="col-6">
            <div className="form-group m-t-25">
              {__check(["CHECK_USER_EMAIL"]).status &&
                <i className="fa fa-spinner fa-spin"/>
              }
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="avnet-modal modal-730">
        <div className="avnet-modal-inner">
          <button
            type="button"
            className="close py-3"
            data-dismiss="modal"
            onClick={() => {
              onHide();
            }}
          >
            ×
          </button>
          {ReusableDiv.PopupTitle("Add User")}
          <div className="modal-body">
            <ShowAlert onlyShowMessage={['addUserError']}/>

            <form>

              <p className="fw-bold">
                Please select the type of user you would like to add:
              </p>
              <div className="bs5 row">
                <div className="form-check-inline d-inline-flex align-items-center">
                  <div className="form-check form-check-inline d-inline-flex align-items-center pr-5 pb-3">
                    <input
                      type="radio"
                      className="form-check-input font-14"
                      id="externalUser"
                      // value={userDetail?.externalUser}
                      onChange={({ target: { checked } }) =>
                        onValueChange("userType", EXTERNAL)
                      }
                      name="users"
                      defaultChecked
                    />
                    <label
                      className="form-check-label mt-0 ms-2"
                      htmlFor="externalUser"
                    >
                      External User
                    </label>
                  </div>
                  <div className="form-check form-check-inline d-inline-flex align-items-center pr-5 pb-3">
                    <input
                      type="radio"
                      className="form-check-input font-14"
                      id="internalUser"
                      // value={userDetail?.internalUser}
                      onChange={({ target: { checked } }) =>
                        onValueChange("userType", INTERNAL)
                      }
                      // value="Internal User"
                      name="users"
                    />
                    <label
                      className="form-check-label mt-0 ms-2"
                      htmlFor="internalUser"
                    >
                      Internal User
                    </label>
                  </div>
                </div>
              </div>
              {UserFields()}
            </form>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              type="button"
              disabled={loader}
              className="bs5 btn btn-secondary minw140"
              onClick={onHide}
            >Cancel</button>
            <button
              type="button"
              className="bs5 btn btn-primary minw140"
              disabled={loader || !enableField}
              onClick={onSaveUser}
            >{loader ? <i className="fa fa-spinner fa-spin "/> : "Add User"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
